import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PageContainer from '../../components/PageContainer';
import SessionConversionFilters from '../../components/SessionConversionFilters';
import SessionConversionStats from '../../components/SessionConversionStats';
import Skeleton from '@mui/material/Skeleton';
import { IStore } from '../../store/types';
import { getSessionConversionStatsThunk } from '../../store/thunk/sessionConversion';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import DataObjectOutlinedIcon from '@mui/icons-material/DataObjectOutlined';
import { AppDialog, EmptyState, PageHeader, Panel } from '../../components/ui';
import { useTheme } from '@mui/material';

const SessionConversionPage = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const sessionConversion = useSelector((state: IStore) => state.sessionConversion);
    const data = sessionConversion?.data;
    const status = sessionConversion?.status;
    const error = sessionConversion?.error;
    const queryParams = sessionConversion?.queryParams;
    const [rawOpen, setRawOpen] = useState(false);

    useEffect(() => {
        if (!data && !status) {
            const today = new Date();
            dispatch<any>(getSessionConversionStatsThunk({
                createdAt_min: today.toISOString().slice(0, 10),
                createdAt_max: today.toISOString().slice(0, 10)
            }));
        }
    }, [data, status, dispatch]);

    const handleFilter = (params: { createdAt_min: string, createdAt_max: string }) => {
        dispatch<any>(getSessionConversionStatsThunk(params));
    };

    return (
        <PageContainer constrained>
            <PageHeader
                eyebrow="Mockups"
                title="Session conversion"
                subtitle="Session funnel of the mockup pipeline: sessions, uploads, add to cart and orders."
                actions={data ? (
                    <Button variant="outlined" size="small" startIcon={<DataObjectOutlinedIcon />} onClick={() => setRawOpen(true)}>
                        Raw data
                    </Button>
                ) : undefined}
            />
            <Panel padding="none" className="report-filters">
                <SessionConversionFilters onFilter={handleFilter} loading={status === 'loading'} defaultParams={queryParams} />
            </Panel>
            <div style={{ width: '100%', position: 'relative', minHeight: 300, marginTop: 20 }}>
                {status === 'loading' && <Skeleton animation="wave" width="100%" height={300} variant="rounded" />}
                {error && (
                    <Panel>
                        <EmptyState title="The report could not be loaded" hint={String(error)} />
                    </Panel>
                )}
                {data && <SessionConversionStats stats={data} />}
            </div>
            <AppDialog
                open={rawOpen}
                onClose={() => setRawOpen(false)}
                title="Raw response"
                maxWidth="md"
                actions={<Button variant="outlined" onClick={() => setRawOpen(false)}>Close</Button>}
            >
                <Box
                    component="pre"
                    sx={{
                        m: 0,
                        background: theme.custom.color.surfaceMuted,
                        border: `1px solid ${theme.custom.color.border}`,
                        borderRadius: 2,
                        p: 2,
                        fontSize: 13,
                        fontFamily: theme.custom.font.mono,
                        maxHeight: 500,
                        overflow: 'auto',
                        color: theme.palette.text.primary,
                    }}
                >
                    {JSON.stringify(data, null, 2)}
                </Box>
            </AppDialog>
        </PageContainer>
    );
};

export default SessionConversionPage;

